import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { MANUFACTURER_REQUEST_STATUSES, ManufacturerRequest, PIN_STATUSES, PIN_TYPES, WARRANTY_TYPES } from "models";
import type { PAGE_SIZE } from "utils/common";

export enum MANUFACTURER_QUESTION_RESULT_STATUS_FILTER {
  Ok = 1,
  Advise,
  Critical
}

export type ManufacturerDashboardFilters = {
  mechanic_fixed: boolean | null;
  page: number;
  pin_status_id: PIN_STATUSES[] | null;
  pin_type_id: PIN_TYPES[] | null;
  request_status: MANUFACTURER_REQUEST_STATUSES | null;
  search_term: string | null;
  status: MANUFACTURER_QUESTION_RESULT_STATUS_FILTER | null;
  warranty_type_id: WARRANTY_TYPES | null;
  dealer_ids: number[];
  location_ids: number[];
  page_size: PAGE_SIZE;
};

// TODO: ask backenders to rename this so we can use items: PaginatedItems<ManufacturerRequest>
export type PaginatedManufacturerRequests = {
  manufacturer_requests: ManufacturerRequest[];
  nb_pages: number;
  nb_items: number;
};

const component = "ManufacturerDashboard";

export const ManufacturerQueryKeys = {
  dashboardFilters: localQueryKey<ManufacturerDashboardFilters>({ component, data: "dashboardFilters" }),
  manufacturerListRequests: (params: ManufacturerDashboardFilters) =>
    backendQueryKey<PaginatedManufacturerRequests>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/manufacturers/requests/list", params }),
  manufacturerRequestCount: backendQueryKey<number>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/manufacturers/requests/pending_count" })
};
